import React, { useMemo } from 'react';
import './Hotspots.scss'
import ItemsInfo from '../ItemsInfo/ItemsInfo';
import { getStatusClass } from '../../../functions/methods';
import { animated } from '@react-spring/web';

const Hotspots = ({ items, linkAreas=[], project, styles, activeImg, sizes, viewBox, highlightAreas, setHoverHouseID, updateMousePos, setActiveHouseID, mousePos, hoverHouseID, activeHouseID, ...props}) => {

    function updateInfoPosition(_x, _y) {
        let mouseX = _x - sizes.diff.x;
        let mouseY = _y - sizes.diff.y;
        const infoSize = { w: 250, h: 250 };

        if (mouseX > (sizes.pageWidth - sizes.diff.x - infoSize.w)) {
            mouseX = mouseX - (infoSize.w / 1.5);
        }
        else if (mouseX < infoSize.w) {
            mouseX = mouseX + (infoSize.w * 0.25);
        }

        if (mouseY > (sizes.pageHeight - sizes.diff.y * 2 - infoSize.h)) {
            mouseY = mouseY - infoSize.h;
        }

        if (isNaN(mouseX) || isNaN(mouseY)) {
            return false;
        }

        mouseX = isNaN(mouseX) ? 0 : mouseX;
        mouseY = isNaN(mouseY) ? 0 : mouseY;

        updateMousePos(
            {
                x: mouseX,
                y: mouseY
            }
        );
    }

    function hoverHouse(e, id) {
        // console.log('hover hus');
        setHoverHouseID("text-" + id);

        let _x = e.pageX;
        let _y = e.pageY;

        updateInfoPosition(_x, _y);

    }

    function clickHouse(id) {
        setActiveHouseID("text-" + id);
        // console.log('klick hus', activeHouseID);

    }

    function mouseOutInfo() {
        // console.log('musen rör sig ut');
        setHoverHouseID(false);
    }

    function parsePoints(points) {
        return points
        .trim()
        .split(/\s+/)
        .map((pair) => {
        const [xStr, yStr] = pair.split(",");
        const x = Number(xStr);
        const y = Number(yStr);
        if (!Number.isFinite(x) || !Number.isFinite(y)) {
            throw new Error(`Invalid point: "${pair}"`);
        }
        return { x, y };
        });
    }

    function averageCenter(pts) {
        const n = pts.length || 1;
        const sum = pts.reduce(
            (acc, p) => ({ x: acc.x + p.x, y: acc.y + p.y }),
            { x: 0, y: 0 }
        );
        return { x: sum.x / n, y: sum.y / n };
    }


    

    return (
        <div className="hotspots" onMouseMove={highlightAreas}>
            <animated.svg style={styles} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                viewBox={viewBox}>
                {
                    Object.keys(items).map((area, key) => {
                        let _points = items[area].points ? items[area].points[activeImg] : null;
                        const status = getStatusClass(items[area].status);
                        if(!_points)return false;
                        return (
                            <g key={'area_' + key} id={'area_' + items[area].id} className={status}>
                                <polygon points={_points}
                                    onMouseMove={(e) => hoverHouse(e, items[area].id)}
                                    onClick={(e) => clickHouse(items[area].id)}
                                    onMouseLeave={mouseOutInfo} />
                            </g>
                        )

                    })
                }
                {
                    Object.entries(linkAreas).map(([areaId, area]) => {
                        // console.log('area',area, areaId);
                        
                        let _points = area.points ? area.points[activeImg] : null;
                        const href = area.url;
                        
                        if(!_points)return false;
                        const pts = parsePoints(_points);
                        const center = averageCenter(pts);
                        return (
                            <g key={'link_area_' + areaId} id={'link_area_' + areaId} className={''}>
                                <a href={href} target="_blank" rel="noopener noreferrer" >
                                
                                <polygon points={_points}
                                    // onMouseMove={(e) => hoverHouse(e, linkAreas[area].id)}
                                    // onMouseLeave={mouseOutInfo} 
                                    />
                                <text 
                                    x={center.x}
                                    y={center.y}
                                    textAnchor="middle"
                                    dominantBaseline="middle"
                                    pointerEvents="none"
                                >{area.text}</text>
                                </a>
                            </g>
                        )

                    })
                }
            </animated.svg>



            <ItemsInfo
                items={items}
                project={project}
                mousePos={mousePos}
                hoverHouseID={hoverHouseID}
                activeHouseID={activeHouseID}
                admin={props.admin}
                projectID={props.projectID}
                setActiveHouseID={setActiveHouseID}
                activeImgID={activeImg}
            />
        </div>
    );
};

export default Hotspots;